import { SumoLoggerOptions } from 'sumo-logger';
import { Observable } from 'rxjs';

export interface IApiUrl {
  url: string;
  version?: string;
  fullUrl?: string;
}

export class ApiUrl implements IApiUrl {
  fullUrl = `${this.url}${this.version ? `/${this.version}` : ''}`;
  constructor(public url: string, public version?: string) {}
}

export interface IAppConfig extends Record<string, unknown> {
  brand: string;
  campaignCode?: string;
  cardToken?: IApiUrl;
  contentful?: Record<string, unknown>;
  gtm?: string;
  logo: any; // TODO: really need to reference type here.
  partner?: string;
  policies?: IApiUrl;
  production: boolean;
  products?: IApiUrl;
  purchasePath?: string;
  quote?: IApiUrl;
  stage: string;
  kosmos?: {
    url: string;
    fullUrl: string;
  };
  sumo?: SumoLoggerOptions;
  theme?: string;
  title?: string;
  users?: IApiUrl;
  tealium?: {
    script: string;
  };
  newRelic?: string;
}

export type AppInit = () => Observable<any>;
export type AppConfigMap = { [key: string]: IAppConfig } & {
  sumo: SumoLoggerOptions;
};

export enum Stage {
  Local = 'loc',
  Kaos = 'kaos',
  Prod = 'prod',
}

export const defaultConfigState: IAppConfig = {
  production: false,
  brand: '',
  logo: 'logo',
  stage: Stage.Kaos,
};
